import { theme } from '@theme';
import { FC, MouseEvent } from 'react';
import loader from '@assets/svgs/load.svg';
import { useSearchDeals } from '@hooks/header/UseSearchDeals';
import { getGuid } from '@services/utils/HelperFunctions';
import { Icon } from '@components/style/Icon';
import {
  Actions,
  LoadingIndicator,
  SearchHistory,
  SearchWrapperContainer,
  WrapperPadding,
} from './SearchWrapperStyles';

type SearchWrapperProps = {
  isNoResultsVisible: boolean;
  isLoadingIndicatorVisible: boolean;
  isHistoryVisible: boolean;
  onSearchHistoryClick: (term: string, e: MouseEvent<HTMLElement>) => void;
  onClearHistory: () => void;
};

const SearchWrapper: FC<SearchWrapperProps> = ({
  isHistoryVisible,
  isLoadingIndicatorVisible,
  isNoResultsVisible,
  onSearchHistoryClick,
  onClearHistory,
}) => {
  const { searchHistory } = useSearchDeals();

  return (
    <SearchWrapperContainer data-testid='search-wrapper'>
      {isNoResultsVisible && (
        <WrapperPadding data-testid='no-deals-found'>
          <p>No deals found, please try another query.</p>
        </WrapperPadding>
      )}
      {isLoadingIndicatorVisible && (
        <LoadingIndicator
          isLoadingIndicatorVisible={isLoadingIndicatorVisible}
          data-testid='loading-indicator'
        >
          <p className='loading'>
            <img src={loader} />
            <span>Searching</span>
          </p>
        </LoadingIndicator>
      )}
      {isHistoryVisible && (
        <WrapperPadding data-testid='history-wrapper'>
          <SearchHistory>
            <h1>Recent Searches</h1>
            <ul className='recent-queries list-unstyled'>
              {searchHistory.map((history: string) => {
                return (
                  <li onClick={(e) => onSearchHistoryClick(history, e)} key={getGuid()}>
                    {history}
                  </li>
                );
              })}
            </ul>
            <Actions>
              <a onClick={onClearHistory} data-testid='clear-history-link'>
                <Icon type='trash' size={theme.typography.h3} additionalClassName='am-icon' />
                {' Clear history'}
              </a>
            </Actions>
          </SearchHistory>
        </WrapperPadding>
      )}
    </SearchWrapperContainer>
  );
};

export default SearchWrapper;
